// src/contexts/PermissionContext.js
import { createContext, useContext, useEffect, useState } from 'react';
import { getMyPermissions } from '../services/PermissionService';
import { useAuth } from './AuthContext';  // 🧠 Add this!

const PermissionContext = createContext(null);

export function PermissionProvider({ children }) {
  const { user } = useAuth(); // 🧠 track user from AuthContext
  const [permissions, setPermissions] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchPermissions() {
      if (!user) {
        setPermissions({});   // No user logged in, no permissions
        setLoading(false);
        return;
      }
      try {
        const perms = await getMyPermissions();
        setPermissions(perms);
      } catch (error) {
        console.error('Failed to fetch permissions', error);
        setPermissions({});
      } finally {
        setLoading(false);
      }
    }

    fetchPermissions();
  }, [user]);  // 🧠 very important: depends on user

  return (
    <PermissionContext.Provider value={{ permissions, loading }}>
      {children}
    </PermissionContext.Provider>
  );
}

export function usePermissions() {
  return useContext(PermissionContext);
}
